// @flow
import * as React from 'react'
import QuestionCircleIcon from 'mz-icons/question-circle'
import InfoCircleIcon from 'mz-icons/info-circle'
import Tooltip from '../Tooltip'
import { HelpButton } from './elements'

// Types
type Props = {
  content?: Function,
  color?: string,
  width?: string,
  placement?: string,
  size: 'normal' | 'inherit',
  appearance?: 'question' | 'info',
}

// Constants
const APPEARANCES = {
  question: QuestionCircleIcon,
  info: InfoCircleIcon,
}

/**
 *
 * @param  {Object} props
 * @return {React.Element}
 */
const HelpTooltip = ({
  content,
  color = 'gray',
  width = '150px',
  placement = 'top',
  appearance = 'question',
  size = 'normal',
}: Props) => {
  const IconComponent = APPEARANCES[appearance] || APPEARANCES.question
  return (
    <Tooltip
      wrapper="span"
      content={content}
      width={width}
      placement={placement}
      target={(innerRef, targetProps) => (
        <HelpButton {...targetProps} ref={innerRef} $color={color} $size={size}>
          <IconComponent />
        </HelpButton>
      )}
    />
  )
}

export default HelpTooltip
